import type { NextPage } from 'next';

import { Footer, GradientBg, Header } from '../components';

const licenses = [
  { state: 'AK', license: '3001980864' },
  { state: 'AL', license: '3001983266' },
  { state: 'AR', license: '3001951162' },
  { state: 'AZ', license: '3001951163' },
  { state: 'CO', license: '746948' },
  { state: 'CT', license: '3001951133' },
  { state: 'DC', license: '3001951166' },
  { state: 'DE', license: '3001951156' },
  { state: 'GA', license: '224627' },
  { state: 'HI', license: '562149' },
  { state: 'IA', license: '3001951278' },
  { state: 'ID', license: '930498' },
  { state: 'IL', license: '3001951176' },
  { state: 'IN', license: '3797468' },
  { state: 'KS', license: '3001951154' },
  { state: 'KY', license: 'DOI-1206283' },
  { state: 'LA', license: '989714' },
  { state: 'MA', license: '3001966014' },
  { state: 'MD', license: '3001960975' },
  { state: 'ME', license: 'AGN419136' },
  { state: 'MI', license: '0138261' },
  { state: 'MN', license: '40804415' },
  { state: 'MO', license: '3001959370' },
  { state: 'MS', license: '15043690' },
  { state: 'MT', license: '3001955872' },
  { state: 'NC', license: '3001951120' },
  { state: 'ND', license: '3001951193' },
  { state: 'NE', license: '3001951265' },
  { state: 'NH', license: '3001962704' },
  { state: 'NJ', license: '3001951219' },
  { state: 'NM', license: '3001963203' },
  { state: 'NV', license: '3796942' },
  { state: 'NY', license: 'BR-1732478' },
  { state: 'NY', license: 'PC-1732478' },
  { state: 'OH', license: '1438287' },
  { state: 'OK', license: '3001951225' },
  { state: 'OR', license: '3001958115' },
  { state: 'PA', license: '1074225' },
  { state: 'RI', license: '3001951239' },
  { state: 'SC', license: '3001951246' },
  { state: 'SD', license: '10029584' },
  { state: 'TN', license: '3001951109' },
  { state: 'TX', license: '2845411' },
  { state: 'UT', license: '930800' },
  { state: 'VA', license: '154136' },
  { state: 'VT', license: '3001951090' },
  { state: 'WA', license: '1159460' },
  { state: 'WI', license: '3001951216' },
  { state: 'WV', license: '3001952083' },
  { state: 'WY', license: '512111' },
  { state: 'CA', license: '6008027' },
  { state: 'FL', license: 'L118858' }
].sort((a, b) => a.state.localeCompare(b.state));

const Licenses: NextPage = () => {
  return (
    <>
      <GradientBg />
      <Header />
      <div className="relative mx-auto pt-16 lg:pt-32 px-4 prose prose-lg">
        <div className="text-center">
          <h1>Coverdash Licenses</h1>
        </div>
        <div className="mt-16">
          <ul className="list-disc md:grid md:grid-cols-3">
            {licenses.map(({ state, license }) => (
              <li key={license} className="flex space-x-2">
                <span className="font-semibold">{state}</span>
                <span>{license}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Licenses;
